import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Tables } from "@/integrations/supabase/types";

export const SupportivePackages = () => {
  const { data: packages, isLoading } = useQuery({
    queryKey: ["supportive-packages"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("supportive_packages")
        .select("*")
        .order("created_at", { ascending: false });

      if (error) throw error;
      return data as Tables<"supportive_packages">[];
    },
  });

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-brand-primary" />
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold text-text-primary mb-8">Hazırlık Paketleri</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {packages?.map((pack) => (
          <div key={pack.id} className="border rounded-lg p-6 shadow-lg">
            {pack.photo_url && (
              <img
                src={pack.photo_url}
                alt={pack.name}
                className="w-full h-48 object-cover rounded-lg mb-4"
              />
            )}
            <h2 className="text-2xl font-bold text-text-primary mb-2">{pack.name}</h2>
            <p className="text-text-secondary mb-4">{pack.description}</p>
            <div className="mb-4">
              <h3 className="font-semibold mb-2">İçerik:</h3>
              <ul className="list-disc list-inside">
                {pack.content.map((item, index) => (
                  <li key={index} className="text-text-secondary">{item}</li>
                ))}
              </ul>
            </div>
            <div className="text-xl font-bold text-brand-primary">
              {pack.price === 0 ? "Ücretsiz" : `${pack.price} TL`}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};